"use client";

import React, { useState } from 'react';
import { QrScanner } from 'react-qrcode-scanner';
import { Button } from '@vaiu/ui/button';

export interface QRCodeScannerProps {
  onComplete: (data: string | null) => void;
}

const QRCodeScanner = ({ onComplete }: QRCodeScannerProps) => {
  const [error, setError] = useState<string | null>(null);

  const handleScan = (data: unknown) => {
    if (data) {
      onComplete(String(data));
    }
  };

  const handleError = (err: { name?: string }) => {
    console.error(err);
    let errorMessage = `An error occurred: ${err.name}`;
    if (err.name === 'NotAllowedError') {
      errorMessage = 'Camera access was denied. Please enable it in your browser settings.';
    }
    setError(errorMessage);
  };

  return (
    <div className="space-y-2">
      <div className="overflow-hidden rounded-lg border aspect-square qr-scanner-container mirrored">
        <QrScanner
          onScan={handleScan}
          onError={handleError}
          style={{ width: '100%', height: '100%' }}
        />
      </div>

      {error && <p className="text-sm text-center text-destructive py-2">{error}</p>}

      <Button onClick={() => onComplete(null)} className="w-full" variant="outline">
        Cancel
      </Button>
    </div>
  );
};

export default QRCodeScanner;
